module.exports = __webpack_public_path__ + "static/media/Kuhn.d1cb8ca5.mp4";